export default __webpack_public_path__ + "static/media/us.210a6e95.jpg";